import { render, staticRenderFns } from "./EsTermsOfUse.vue?vue&type=template&id=f349724c&scoped=true"
import script from "./EsTermsOfUse.vue?vue&type=script&lang=js"
export * from "./EsTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f349724c",
  null
  ,true
)

export default component.exports